/**
 * Created by wangjianwen on 2017/10/16.
 */
import Lockr from 'lockr'
export default {
    getCurrentExamInfo(states){
        return states.currentExamInfo;
    },
    getBatch(states){
        return states.batch;
    },
    getApiState(states){
        return states.api_state;
    },
};